import './SalesforceOrganizationSyncConfigurationButton.scss';
import { ADMIN_DASHBOARD_COPY } from '@sonar-software/sonar-ts-constants';
import { AsyncStateNotification } from '@ui/notifications';
import { coreActions } from '@sonar-software/sonar-core';
import { createAsyncSelectors } from '@lib/selectors';
import { LoadingSpinner } from '@ui/LoadingSpinner';
import { SettingOutlined } from '@ant-design/icons';
import { SonarModal } from '@ui/modals';
import { Button, Form, Select, Switch } from 'antd';
import React, { useCallback, useEffect, useState } from 'react';
import { useAction, useSonarSelector } from '@hooks';
const getSonarTaskConfigSelectors = createAsyncSelectors((state) => state.core.organizations.byId.tasks.types.configs.get);
const patchSonarTaskConfigSelectors = createAsyncSelectors((state) => state.core.organizations.byId.tasks.types.configs.patch);
export const SalesforceOrganizationSyncConfigurationButton = (props) => {
    const { organizationId, organizationName, shardName } = props;
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isTaskEnabled, setIsTaskEnabled] = useState(true);
    const [taskFrequency, setTaskFrequency] = useState(0);
    const sonarTaskConfig = useSonarSelector(getSonarTaskConfigSelectors.data);
    const sonarTaskConfigRequested = useSonarSelector(getSonarTaskConfigSelectors.isRequested);
    const sonarTaskConfigPatching = useSonarSelector(patchSonarTaskConfigSelectors.isRequested);
    const getSonarTaskConfig = useAction(coreActions.requestGetCoreSonarTaskConfigsByOrganizationIdAndTaskType);
    const patchSonarTaskConfig = useAction(coreActions.requestPatchCoreSonarTaskConfigsByOrganizationIdAndTaskType);
    const handleOpenConfigureImports = useCallback(() => {
        setIsModalOpen(true);
    }, [setIsModalOpen]);
    const handleConfigureImportsOk = useCallback(() => {
        if (organizationId) {
            const request = {
                enabled: isTaskEnabled,
                minDaysInterval: taskFrequency,
                organizationId,
                shardName,
                taskType: 'sfdc-import'
            };
            patchSonarTaskConfig(request);
        }
    }, [organizationId, isTaskEnabled, taskFrequency, patchSonarTaskConfig]);
    const handleConfigureImportsCancel = useCallback(() => {
        setIsModalOpen(false);
    }, [setIsModalOpen]);
    const handleFrequencyChanged = useCallback((value) => {
        setTaskFrequency(value);
    }, [setTaskFrequency]);
    const handleEnabledChanged = useCallback((enabled) => {
        setIsTaskEnabled(enabled);
    }, [setIsTaskEnabled]);
    useEffect(() => {
        if (isModalOpen && organizationId) {
            getSonarTaskConfig({
                organizationId,
                shardName,
                taskType: 'sfdc-import'
            });
        }
    }, [getSonarTaskConfig, isModalOpen, organizationId, shardName]);
    useEffect(() => {
        if (sonarTaskConfig) {
            setIsTaskEnabled(sonarTaskConfig.enabled);
            setTaskFrequency(sonarTaskConfig.minDaysInterval);
        }
    }, [sonarTaskConfig]);
    useEffect(() => {
        if (!sonarTaskConfigPatching) {
            setIsModalOpen(false);
        }
    }, [sonarTaskConfigPatching]);
    if (!organizationId || !organizationName) {
        return null;
    }
    return (React.createElement("span", null,
        React.createElement(Button, { icon: React.createElement(SettingOutlined, null), onClick: handleOpenConfigureImports }, ADMIN_DASHBOARD_COPY.CONFIGURE_IMPORTS),
        React.createElement(SonarModal, { className: 'import-frequency-modal', okButtonProps: { disabled: sonarTaskConfigRequested || sonarTaskConfigPatching }, onCancel: handleConfigureImportsCancel, onOk: handleConfigureImportsOk, open: isModalOpen, title: ADMIN_DASHBOARD_COPY.CONFIGURE_IMPORTS_FOR(organizationName) },
            React.createElement(LoadingSpinner, { spinning: sonarTaskConfigRequested },
                React.createElement(Form, { colon: false },
                    React.createElement(Form.Item, { label: ADMIN_DASHBOARD_COPY.FREQUENCY },
                        React.createElement(Select, { defaultValue: 0, dropdownStyle: { zIndex: 2000 }, onChange: handleFrequencyChanged, popupClassName: 'modal-dropdown-list', value: taskFrequency },
                            React.createElement(Select.Option, { value: 0 }, ADMIN_DASHBOARD_COPY.FREQUENCY_DAILY),
                            React.createElement(Select.Option, { value: 7 }, ADMIN_DASHBOARD_COPY.FREQUENCY_WEEKLY))),
                    React.createElement(Form.Item, { label: ADMIN_DASHBOARD_COPY.ENABLED },
                        React.createElement(Switch, { checked: isTaskEnabled, onChange: handleEnabledChanged }))))),
        React.createElement(AsyncStateNotification, { errored: ADMIN_DASHBOARD_COPY.PATCH_TASK_CONFIG_ERRORED, failed: ADMIN_DASHBOARD_COPY.PATCH_TASK_CONFIG_FAILED, requested: ADMIN_DASHBOARD_COPY.PATCH_TASK_CONFIG_REQUESTED, stateSelector: patchSonarTaskConfigSelectors.state })));
};
